/* eslint-disable no-nested-ternary */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Checkbox,
  Switch, Popconfirm
} from 'antd';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import { INFINITE_EXPIRY_DATE, QUANTITY, toISTDate } from '@Apis/constants';
import H3FormInput from '@Uilib/h3FormInput';
import Crown from '@Images/crown2.png';
import HideValue from '../../../../../../../Common/RestrictedAccess/HideValue';
import ViewBatchCustomFields from '../../../../../../../Common/ViewBatchCustomFields';
import './style.scss';

class RawMaterialBatchSelector extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isAllBatchesSelected: true,
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps?.batches !== this.props?.batches) {
      const allSelected = this.props?.batches?.length > 0 &&
        this.props?.batches?.every(batch => batch?.batch_in_use);
      if (this.state?.isAllBatchesSelected !== allSelected) {
        this.setState({ isAllBatchesSelected: allSelected });
      }
    }
  }

  onToggleAllBatch = () => {
    const { batches, onToggleBatch, itemsRow } = this.props;
    const { isAllBatchesSelected } = this.state;
    const shouldSelectAll = !isAllBatchesSelected;
    this.setState({ isAllBatchesSelected: shouldSelectAll });

    batches?.forEach((batch) => {
      if (batch?.batch_in_use !== shouldSelectAll) {
        onToggleBatch(batch, itemsRow);
      }
    });
  };

  getColumns() {
    const { priceMasking, hideSelectAllBatchesOption } = this.props;
    const { isDataMaskingPolicyEnable, isHideCostPrice } = priceMasking;
    const { isAllBatchesSelected } = this.state;
    const rawMatrialBatchColumns = [
      {
        title: (
          !hideSelectAllBatchesOption ? (
            <Checkbox
              checked={isAllBatchesSelected}
              onChange={this.onToggleAllBatch}
            />
          ) : null
        ),
        fixed: 'left',
        render: (record) => {
          const { onToggleBatch, itemsRow } = this.props;
          return (
            <Checkbox
              checked={record?.batch_in_use}
              onChange={(event) => onToggleBatch(record, itemsRow, event.target.checked)}
              disabled={record?.is_reserved}
            />
          );
        },
        hidden: false,
      },
      {
        title: 'Batch#',
        render: (text, record) => {
          const { org } = this.props;
          const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
          return (
            <div>
              <H3Text text={record?.custom_batch_number || record?.batch_number} style={{ fontWeight: '500' }} />
              <div className="table-subscript">
                {record?.lot_number && batchConfig?.lot_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Lot#</span>
                      {' '}
                      {record?.lot_number}
                    </span>
                  )}
                  />
                )}
                {record?.ar_number && batchConfig?.ar_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>AR#</span>
                      {' '}
                      {record?.ar_number}
                    </span>
                  )}
                  />
                )}
                {record?.roll_no && batchConfig?.roll_no_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Roll No#</span>
                      {' '}
                      {record?.roll_no}
                    </span>
                  )}
                  />
                )}
                {record?.batch_inward_date && batchConfig?.batch_inward_date_is_enabled && (
                  <div className="batch-list__item-created-by" style={{ paddingBottom: '0px' }}>
                    {`Issued on ${toISTDate(record?.batch_inward_date).format('DD MMM, YY')}`}
                  </div>
                )}
              </div>
              {record?.is_reserved && (
                <div className="status-tag reservation-tag">
                  Reserved
                </div>
              )}
            </div>
          );
        },
        width: '180px',
      },
      {
        title: 'Shelf Life',
        render: (text, record) => {
          const { expiryDays } = this.props;
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100)) > 100 ? 100 : Math.round(((shelfLife / expiryDays) * 100));
          if (record?.expiry_date === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
          if (expiryDays < 0) {
            return (
              <div style={{ width: '220px' }}>
                No Expiry (100%)
              </div>
            );
          }

          return (
            <Fragment>
              {record?.expiry_date !== INFINITE_EXPIRY_DATE ? dayjs(record?.expiry_date).format('DD MMM, YY') : '-'}
              <div className="batch-shelf-life">

                <div
                  className="progress-line__wrapper"
                  style={{
                    width: '120px',
                    backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                  }}
                >
                  <div
                    className="progress-line"
                    style={{
                      width: `${shelfLifePct}%`,
                      backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                    }}
                  />
                </div>
                <span>
                  {record?.expiry_date === INFINITE_EXPIRY_DATE ? 'NA' : `${shelfLife} Days (${shelfLifePct}%)`}
                </span>
              </div>
            </Fragment>
          );
        },
      },
      {
        title: 'Batch Quality',
        render: (text, record) => (
          <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
            {record?.is_rejected_batch ? 'Bad' : 'Good'}
          </div>
        ),
      },
      {
        title: 'Costing',
        render: (text, record) => (
          <Fragment>
            <div>
              {record?.cost_price ? (
                <span>
                  {'Base -'}
                  {' '}
                  {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view costing"} /> : this.props.MONEY(record?.cost_price)}
                </span>
              ) : '-'}
            </div>
            <div>
              {record?.landed_cost ? (
                <span>
                  {'Landed -'}
                  {' '}
                  {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view landed cost"} /> : this.props.MONEY(record?.landed_cost)}
                </span>
              ) : '-'}
            </div>
          </Fragment>
        ),
      },
      {
        title: 'Quantity',
        render: (text, record) => {
          const { uomInfo } = this.props;
          return (
            <div>{`${QUANTITY(record?.available_qty, uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
          );
        },
      },
      {
        title: 'Custom Fields',
        render: (record) => (<ViewBatchCustomFields customFields={record?.custom_fields} />),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: () => {
          const batchConsumedQtyEditable = this.props.user?.tenant_info?.inventory_config?.settings?.enable_batch_consumed_qty_editable;

          return (<div style={{ display: 'flex', alignItems: 'center' }}>
            <div>Consumed</div>
            {!batchConsumedQtyEditable && (
              <Popconfirm
                placement="topRight"
                title="This feature is not accessible within your current plan to use this feature contact us."
                onConfirm={() => window.Intercom('showNewMessage')}
                okText="Contact Us"
                cancelText="Cancel"
              >
                <img
                  className="heading-restrict"
                  src={Crown}
                  alt="premium"
                  style={{
                    marginLeft: '6px',
                    marginTop: '-3px'
                  }}
                />
              </Popconfirm>
            )}
          </div>)
        },
        render: (text, record) => {
          const { uomInfo, user, updateBatchValue } = this.props;
          const batchConsumedQtyEditable = user?.tenant_info?.inventory_config?.settings?.enable_batch_consumed_qty_editable;
          return (
            <React.Fragment>
              {batchConsumedQtyEditable && (
                <H3FormInput
                  value={record?.consumed_qty || ''}
                  type="number"
                  containerClassName={`${(Number(record?.consumed_qty) < 0 || Number(record?.consumed_qty) > Number(record?.available_qty)) ? 'form-error__input' : 0}`}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(event) => {
                    updateBatchValue(event.target.value || 0, 'consumed_qty', record?.batch_id);
                  }}
                  disabled={!batchConsumedQtyEditable || !record?.batch_in_use}
                />
              )}
              <div style={{ color: record?.consumed_qty ? 'red' : 'black' }}>{`${record?.consumed_qty ? '-' : ''}${QUANTITY(record?.consumed_qty || '0', uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
            </React.Fragment>
          );
        },
      },
    ];
    return rawMatrialBatchColumns;
  }

  getBatches(oldBatches, quantity) {
    const batches = oldBatches;
    let remainingQty = new Decimal(quantity || 0);

    // Reset consumed_qty
    for (let i = 0; i < batches?.length; i++) {
      batches[i].consumed_qty = 0;
    }

    for (let i = 0; i < batches?.length; i++) {
      const consumed = new Decimal(batches[i].consumed_qty || 0);
      const available = new Decimal(batches[i].available_qty || 0);

      if (remainingQty.gt(0) && consumed.lt(available)) {
        const consumeQty = Decimal.min(available, remainingQty);
        batches[i].consumed_qty = consumeQty.toNumber();
        remainingQty = remainingQty.minus(consumeQty);
      } else {
        batches[i].consumed_qty = 0;
        // No deduction necessary since it's 0
      }
    }

    return batches;
  }

  render() {
    const {
      batches, updateAllStock, allStock
    } = this.props;
    const rawMatrialBatchColumns = this.getColumns()?.filter((column) => !column.hidden);

    return (
      <div className="rm-batch-selector-wrapper">
        <div className="flex-display">
          <H3Text text="Available Stock Batches" className="rm-batch-selector-title" />
          <div style={{ marginLeft: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                {String(allStock) && (
                  <Switch
                    checked={allStock}
                    onChange={() => {
                      updateAllStock(!allStock);
                    }}
                    checkedChildren="Good Stock Only"
                    unCheckedChildren="All Stock Batches"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <Table
          size="small"
          columns={rawMatrialBatchColumns}
          dataSource={allStock ? batches?.filter((batch) => !batch?.is_rejected_batch) : batches}
          pagination={false}
          bordered
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  org: UserReducers.org,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RawMaterialBatchSelector));
